export const paths = {
  Login: '/login',
  LoginAgent: '/login/:agentSlug',
  Callback: '/callback',
  Assistant: '/assistant',
  AssistantAgent: '/assistant/:agentId',
  Root: '/',
TestCanvas: '/test-canvas',
  TestEventOrchestration: '/test-event-orchestration',
  TestIncidentWorkflow: '/test-incident-workflow',
  TestScroll: '/test-scroll',
  ColorPalette: '/colors',
  BestPractices: '/best-practices',
  BestPracticesOverview: '/best-practices/overview',
  BestPracticesUsers: '/best-practices/users',
  BestPracticesTeams: '/best-practices/teams',
  BestPracticesContactMethods: '/best-practices/contact-methods',
  BestPracticesSchedules: '/best-practices/schedules',
  BestPracticesFlexibleSchedules: '/best-practices/flexible-schedules',
  BestPracticesNotificationRules: '/best-practices/notification-rules',
  BestPracticesEscalationPolicies: '/best-practices/escalation-policies',
  BestPracticesServices: '/best-practices/services',
  BestPracticesAIOps: '/best-practices/aiops',
  BestPracticesIW: '/best-practices/incident-workflows',
  BestPracticesOptimizationChecks: '/best-practices/optimization-checks',
  RuleSummary: '/rule-summary',
  Settings: '/settings',
  // Migration Assistant — standalone overview page accessible only from
  // the migration assistant's right sidebar. Lives outside the chat
  // layout so its hero + 4-step content has the whole viewport.
  MigrationOverview: '/assistant/pd_migration_assitant/overview',
} as const;

export const PATHS = paths;
